/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { roleEnumSchema } from './roleEnumSchema.ts';
import { z } from 'zod';

export const employeeMainDataSchema = z.object({
  id: z.coerce.number().int(),
  lastName: z.coerce.string().optional(),
  firstName: z.coerce.string().optional(),
  email: z.coerce.string().nullable().nullish(),
  phoneNumber: z.coerce.string().nullable().nullish(),
  username: z.coerce.string().optional(),
  timesheetDaysForward: z.coerce.number().int().nullable().nullish(),
  timesheetDaysBackward: z.coerce.number().int().nullable().nullish(),
  registrationNumber: z.coerce.string().nullable().nullish(),
  enabled: z.boolean().optional(),
  hoursPerDay: z.coerce.number().int().nullable().nullish(),
  employeeType: z.lazy(() => roleEnumSchema).optional(),
  hasCv: z.boolean().optional(),
  hasCvPreview: z.boolean().optional(),
  cvUpdateRequested: z.boolean().optional(),
  cvLastUpdatedAt: z.string().datetime({ local: true }).nullable().nullish(),
});
